/* eslint-disable no-use-before-define */
import React from 'react'
import { Disclosures, Loading } from '../../twd'
import { default as useQuickIdeas, onViewAll } from './use-quick-ideas'
import Grid from './grid'

export default () => {

    const { status, data } = useQuickIdeas({
        id: 'QUICK_IDEAS_HIGH_YIELD_CORPS',
        url: '/esb/retailservice/quickIdeasService/getHighYielding',
        params: {
            state: null,
            quickPickGroupSubTypeList: ['QUICK_IDEAS_HIGH_YIELD_CORPS']
        }
    })

    return <React.Fragment>
        <div className="row vertical-offset-sm"></div>
        <div className="row"><div className="col-md-12 col-xs-12">
            <h3 style={{display:'inline-block', paddingRight:'10px'}} className="medium-header">High Yielding</h3>
            <Disclosures
                dataModule='overview-quick-ideas'
                dataCategory='high-yielding'
                dataName='overview-quick-ideas-high-yielding-learn-more-link'
                label='Learn more'
                html={DISCLOSURES} />
        </div></div>

        <div className="row vertical-offset-sm"><div className="col-md-12 col-xs-12">
        Short and medium-term high yield corporates with high coupons and a focus on income generation.
        </div></div>

        <div className="row vertical-offset-sm">
            <div className="col-md-6">&nbsp;</div>
            <div className="col-md-6 equally-spaced">
                <div>Additional Offerings:</div>
                <div><button
                    data-module='overview-quick-ideas'
                    data-category='high-yielding'
                    data-name='overview-quick-ideas-high-yielding-less-than-2-year-link'
                    className="link-button"
                    onClick={() => onView({holdMaturityMax:'2y'})}
                >&lt;2 years</button></div>
                <div><button
                    data-module='overview-quick-ideas'
                    data-category='high-yielding'
                    data-name='overview-quick-ideas-high-yielding-between-2-year-to-5-year-link'
                    className="link-button"
                    onClick={() => onView({holdMaturityMin:'2y', holdMaturityMax:'5y'})}
                >2 - 5 years</button></div>
                <div><button
                    data-module='overview-quick-ideas'
                    data-category='high-yielding'
                    data-name='overview-quick-ideas-high-yielding-between-5-year-to-10-year-link'
                    className="link-button"
                    onClick={() => onView({holdMaturityMin:'5y', holdMaturityMax:'10y'})}
                >&gt;5 - 10 years</button></div>
            </div>
        </div>

        <div className="row"><div className="col-md-12">
        <Loading status={status}>
            <Grid
            dataCategory='high-yielding'
            dataName='overview-quick-ideas-high-yielding'
            rows={data} />
        </Loading>
        </div></div>

    </React.Fragment>
}

const onView = (p) => {
    let searchParams = Object.assign({
        holdInvType: ['C'],
        offeringType: ['secondary','ask-side'],
        holdMoodyRatingMin: 'C',
        holdMoodyRatingMax: 'Ba1',
        holdSpRatingMin: 'C',
        holdSpRatingMax: 'BB+',
        holdCouponTypeCode: ['FNZR'],
        holdCallableInd: ['N'],
        quantityMin: 10,
        clientPriceMin: 95,
        clientPriceMax: 120,
        holdCouponMin: 7,
        holdCouponPayFrequency: ['S'],
        persistToPreviousSearches: false,
        sort: [{ field:'askYield', direction:'DESC' }]
    }, p)
    onViewAll({searchParams})
}

const DISCLOSURES = `
    <p>
    This category features high yield (includes ratings between C/C to Ba1/BB+)
    corporate bond search results with maturities ranging between 2 and 10 years.
    All results displayed are from dealers offering a minimum of 10 bonds,
    with an offering price between 95 and 120.
    All bonds feature a minimum 7% coupon and semi-annual interest payments.
    Each of the three rows feature a unique maturity range.
    Row 1: (<2yr), Row 2: (2yr – 5yr), Row 3: (5yr - 10yr).
    </p>`

